import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import { formateDateAndTime } from "~/utils/utils";
import { useTrans } from '~/hooks/useTrans';
import { IAdminJournalItem } from "~/providers/admin-interfaces";
import Loader from '~/components/Loader';
import JsonViewer from '~/components/JsonViewer';
import { useLang } from "~/hooks/useLang";

interface IAdminJournalsTable {
	loading: boolean;
	items: Array<IAdminJournalItem>;
}

export default function AdminJournalsTable({
	loading = true,
	items = [],
}: IAdminJournalsTable) {
	const { trans, transJournalAction } = useTrans();
	const { isCzech } = useLang();
	const HEADERS = [
		"adminJournalsTable.date",
		"adminJournalsTable.user",
		"adminJournalsTable.action",
		"adminJournalsTable.table",
		"adminJournalsTable.desc",
	];

	function getUser(item: IAdminJournalItem) {
		const isInternal = item.appUser.internal ? ` (${trans("createInternalUserModal.internalRole.internalAdmin")})` : "";

		return `${item.appUser.name} - ${item.appUser.role}${isInternal}`;
	}

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold" }} key={header}>
						{ trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(journal => (<TableRow key={journal.id}>
					<TableCell>
						{ formateDateAndTime(new Date(journal.logTime), isCzech) }
					</TableCell>
					<TableCell>
						{ getUser(journal) }
					</TableCell>
					<TableCell>
						{ transJournalAction(journal.action) }
					</TableCell>
					<TableCell>
						{ `${journal.tableName} [${journal.rowId}]` }
					</TableCell>
					<TableCell>
						<JsonViewer origData={journal.originalData} newData={journal.newData} />
					</TableCell>
				</TableRow>)) }
				{ items.length === 0 && <TableRow>
					<TableCell colSpan={HEADERS.length} style={{ textAlign: "center" }}>
						{ loading && <Loader msg={trans("loadingData")} /> }
						{ !loading && trans("emptyTable") }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
